// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2te8e","footer":"ModalCreateQualiphyProcedure_footer__2D5Ib","additionData":"ModalCreateQualiphyProcedure_additionData__2-OVb"};